import { render, staticRenderFns } from "./PrecisionRetriesBox.vue?vue&type=template&id=fc197c98&"
import script from "./PrecisionRetriesBox.vue?vue&type=script&lang=ts&"
export * from "./PrecisionRetriesBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports